/* @ngInject */
function PostSliderController ($scope, $timeout, SliderService) {
  $scope.sliderClass = 'post-slider'

  $scope.$watch('$$childHead', function () {
    if ($scope.$$childHead) {
      $scope.setOpenSettings({ left: '0' }, 400)
      $scope.setCloseSettings({ left: '-100%' }, 400, function () {
        const content = $scope.$$childHead

        content._postId = undefined
        content._editMode = true
        content._existingPost = false

        content.refreshPost()
      })

      SliderService.register($scope.sliderClass)
      SliderService.registerState($scope.sliderClass, 'open', function (data) {
        const content = $scope.$$childHead

        content._postId = data._postId
        content._editMode = data._editMode
        content._existingPost = data._existingPost

        $timeout(() => {
          content.refreshPost()
        })

        $scope.setSliderOpen(true)
      })

      SliderService.registerState($scope.sliderClass, 'close', function () {
        if ($scope.update) { $scope.update($scope.filters) }
        $scope.setSliderOpen(false)
      })

      SliderService.registerState('post-slider', 'toggle-lock', () => {})

      $scope.handleSliderSendButtonClick = function () {
        $scope.$$childHead.handleSendButtonClick()
          .then(function () {
            $scope.setSliderOpen(false)
            if ($scope.onComplete) { $scope.onComplete() }
          })
          .catch(function () {
            $scope.setSliderOpen(false)
          })
      }

      $scope.handleClosePost = function () {
        SliderService.setState($scope.sliderClass, 'close')
      }
    }
  })
}

export { PostSliderController }
